 /* eslint-disabled */

export default class ReceiptExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
